import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "godDoUser" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "inner" }
const _hoisted_5 = { style: {"display":"flex","justify-content":"end","width":"1300px","gap":"50px","margin-bottom":"20px"} }
const _hoisted_6 = { class: "list" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "pagination",
  style: {"margin-top":"50px","color":"black"}
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

import { ref, onMounted, computed, watch } from 'vue'
import axios from '@/api/files' // axios 인스턴스 경로 확인
import Header from '@/components/admin/adminHeader.vue'
import Sidebar from '@/components/admin/adminSidebar.vue'
import InsertFilesModal from '@/components/admin/insertFiles.vue' // 새로 만든 모달 컴포넌트 임포트
import { useRoute, useRouter } from 'vue-router'

const itemsPerPage = 10 // 한 페이지에 15명씩

export default /*@__PURE__*/_defineComponent({
  __name: 'imageList',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const isModalOpen = ref(false) // 모달 가시성 상태
const userList = ref<any[]>([]) // 사용되지 않는 변수일 경우 제거 가능
const allImagesLoaded = ref(false)
const currentPage = ref(Number(route.query.page) || 1)
const crt = ref('') // 사용되지 않는 변수일 경우 제거 가능
const totalItems = ref(0)
const members = ref<any[]>([]); // 타입 명확화
const selectedCrt = ref('')
const selectedYear = ref('')


const totalPages = computed(() => {
  return members.value.length === 0
    ? 1
    : Math.ceil(totalItems.value / itemsPerPage);
});

// 현재 페이지의 멤버들만 추출
const displayedMembers = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage; 
  const end = start + itemsPerPage;
  return members.value.slice(start, end);
})


// 페이지 변경
function changePage(direction: 'next' | 'prev') {
  if (direction === 'next' && currentPage.value < totalPages.value) {
    currentPage.value++
  } else if (direction === 'prev' && currentPage.value > 1) {
    currentPage.value--
  }
  router.push({ query: { ...route.query, page: currentPage.value } });
}

watch(currentPage, () => {
  fetchMembers()
})

watch([selectedCrt, selectedYear], () => {
  fetchMembers()
  currentPage.value = 1 // 필터 변경 시 첫 페이지로 이동
})

// 이미지 삭제
const deleteImage = async (no: number) => {
  if (!confirm('정말 삭제하시겠습니까?')) return
  try {
    await axios.deleteImage(no)
    alert('삭제되었습니다.')
    fetchMembers() // 삭제 후 리스트 갱신
  } catch (err) {
    console.error('삭제 실패', err)
    alert('삭제 중 오류가 발생했습니다.')
  }
}

async function fetchMembers() {
  try {
    const response = await axios.fetchFiles({
      crt: selectedCrt.value,
      trueDay: selectedYear.value,
      page: currentPage.value - 1, // Spring Data JPA Pageable은 0부터 시작하므로 -1
      rows: itemsPerPage,
    })
    console.log("Fetched Data:", response.data)
    members.value = response.data.list || []
    totalItems.value = response.data.total || 0
    allImagesLoaded.value = true
  } catch (error) {
    console.error('멤버 목록을 불러오는 데 실패했습니다:', error)
  }
}

const formatDate = (dateStr: string) => {
  return new Date(dateStr).toLocaleString()
}

onMounted(() => {
  fetchMembers()
})

// 모달 열기 함수
const openInsertModal = () => {
  isModalOpen.value = true
}

// 모달 닫기 함수
const closeInsertModal = () => {
  isModalOpen.value = false
}

const handleImageAdded = () => {
  fetchMembers() // 이미지 목록 새로고침
}


const getCrtName = (crtValue: string | number): string => {
  const map: Record<string, string> = {
    '1': '키나',
    '2': '문샤넬',
    '3': '예원',
    '4': '하나',
    '5': '아테나',
  }

  if (typeof crtValue === 'number') {
    return map[crtValue.toString()] || '알 수 없음'
  }

  if (typeof crtValue === 'string') {
    // 쉼표로 구분된 문자열 처리 (예: "1, 3")
    return crtValue
      .split(',')
      .map(c => map[c.trim()] || '알 수 없음')
      .join(', ')
  }

  return '알 수 없음'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, [
            _createElementVNode("h1", null, "이미지 목록")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCrt).value = $event))
            }, _cache[4] || (_cache[4] = [
              _createStaticVNode("<option value=\"\" data-v-4b5aaaae> 전체 카테고리 </option><option value=\"1\" data-v-4b5aaaae> 키나 </option><option value=\"2\" data-v-4b5aaaae> 문샤넬 </option><option value=\"3\" data-v-4b5aaaae> 예원 </option><option value=\"4\" data-v-4b5aaaae> 하나 </option><option value=\"5\" data-v-4b5aaaae> 아테나 </option>", 6)
            ]), 512), [
              [_vModelSelect, selectedCrt.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedYear).value = $event))
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("option", { value: "" }, " 전체 연도 ", -1),
              _createElementVNode("option", { value: "2024" }, " 2024년 ", -1),
              _createElementVNode("option", { value: "2025" }, " 2025년 ", -1)
            ]), 512), [
              [_vModelSelect, selectedYear.value]
            ]),
            _createElementVNode("button", {
              class: "button",
              onClick: openInsertModal
            }, " 등록 ")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", null, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "이미지"),
                  _createElementVNode("th", null, "멤버 이름"),
                  _createElementVNode("th", null, "사진 연도"),
                  _createElementVNode("th", null, "등록일자"),
                  _createElementVNode("th", null, "삭제")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedMembers.value, (member) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: member.no
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("img", {
                        src: member.path,
                        alt: member.path,
                        class: "member-img",
                        style: {"height":"60px"}
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(getCrtName(member.crt)), 1),
                    _createElementVNode("td", null, _toDisplayString(member.trueDay || '없음'), 1),
                    _createElementVNode("td", null, _toDisplayString(formatDate(member.createdAt)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (deleteImage(member.no))
                      }, " 삭제 ", 8, _hoisted_8)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              disabled: currentPage.value === 1,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage('prev')))
            }, " Previous ", 8, _hoisted_10),
            _createElementVNode("span", null, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value), 1),
            _createElementVNode("button", {
              disabled: currentPage.value === totalPages.value,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage('next')))
            }, " Next ", 8, _hoisted_11)
          ])
        ])
      ])
    ]),
    (isModalOpen.value)
      ? (_openBlock(), _createBlock(InsertFilesModal, {
          key: 0,
          onClose: closeInsertModal,
          onImageAdded: handleImageAdded
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})